import SyNavButton from "./sy-nav-button";

export default SyNavButton